<!-- PCBA 总费用明细 -->
<template>
  <div class="price-total-view">
    <div class="price-view">
      <ul>
        <!-- PCB制作费 -->
        <li v-if="showPcb">
          <span class="price-view__label">
            PCB总费用：
          </span>
          <span class="price-view__value has-handle" :class="{'has-active': !!pcbDiscountAmount}">
            <BaseTipPopover disabled @click.native="handlePcbFee">
              <i slot="reference" class="price-view__handle" />
            </BaseTipPopover>
            <span v-if="isFpcNeedAudit && ['FPC_SMT', 'SMT_FPC'].includes(type)" style="color: #E6A23C">
              以审核为准
            </span>
            <template v-else>
              ￥{{ pcbAmount }}
            </template>
            <span v-if="pcbDiscountAmount" class="has-active__tips">
              {{ pcbDiscountAmount }}
            </span>
          </span>
        </li>
        <!-- SMT加工费 -->
        <li>
          <span class="price-view__label">
            SMT总费用：
          </span>
          <span class="price-view__value has-handle">
            <BaseTipPopover disabled @click.native="handleSmtFee">
              <i slot="reference" class="price-view__handle" />
            </BaseTipPopover>
            ￥{{ smtAmount }}
          </span>
        </li>
        <!-- BOM物料费 -->
        <li v-if="showBom">
          <span class="price-view__label">
            BOM物料费：
          </span>
          <template v-if="data.bomPrice">
            <!-- 华秋帮我选型 -->
            <span v-if="data.bomPrice.buy_bom == 1 || data.bomPrice.modelSelectionType === 0" class="price-view__value has-handle">
              <i />
              <span style="color: #aaa">
                待人工报价
              </span>
            </span>
            <!-- 自助匹配选型 -->
            <span v-else class="price-view__value has-handle">
              <BaseTipPopover disabled @click.native="handleBomFee">
                <i slot="reference" class="price-view__handle" />
              </BaseTipPopover>
              <span v-if="data.bomPrice.modelSelectionType === 2" style="color: #aaa">
                待人工报价
              </span>
              <template v-else>
                ￥{{ bomAmount }}
              </template>
            </span>
            <div v-if="data.bomPrice.modelSelectionType === 2" class="price-view__desc">
              <span>
                已配器件：<span>￥{{ bomAmount }}</span>
                 <div class="tips-text" v-if = "+data.bom_order_wide_discount>0" >
                    &lpar;优惠已减：-￥{{ data.bom_order_wide_discount||0 }}&rpar;
                 </div>
               ，待询价/代配器件：<span>待人工报价</span>
              </span>
            </div>
            <!-- 一站式下单v3.1迭代 -->
            <template v-else>
              <div class="tips-box" v-if = "+data.bom_order_wide_discount>0" >
                <span class="tips-content">
                  贴片元件优惠已减：-￥{{ data.bom_order_wide_discount||0 }}
                </span>
              </div>
            </template>
          </template>
        </li>
      </ul>
    </div>
    <!-- 费用明细弹框 -->
    <FeeFieldsDialog ref="feeFieldsDialogRef" />
    <!-- BOM查看明细弹框 -->
    <BomItemDialog ref="bomItemDialogRef" />
  </div>
</template>

<script>
// 费用明细弹框
import FeeFieldsDialog from '../components/feeFieldsDialog'
// BOM查看明细弹框
import BomItemDialog from '../components/bomItemDialog'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      validator: function (value) {
        return ['PCB', 'FPC', 'SMT', 'PCB_SMT', 'FPC_SMT', 'SMT_PCB', 'SMT_FPC'].includes(value)
      }
    },
    isFpcNeedAudit: {
      type: Boolean,
      default: false
    },
    showPcb: {
      type: Boolean,
      default: false
    },
    showBom: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FeeFieldsDialog,
    BomItemDialog
  },
  computed: {
    pcbAmount() {
      return (+(this.data.pcb_amount || 0)).toFixed(2)
    },
    // PCB活动折扣
    pcbDiscountAmount() {
      if (this.data.detail && this.data.detail.pcb) {
        const discount_amount = this.data.detail.pcb.discount_amount || 0
        return discount_amount > 0 ? `活动已减：-￥${discount_amount}` : ''
      }
      return ''
    },
    smtAmount() {
      let val = 0
      if (this.data.detail && this.data.detail.smt) {
        val = this.data.detail.smt.smt_order_fee || 0
      }
      return val.toFixed(2)
    },
    bomAmount() {
      return (+this.data.bom_amount || 0).toFixed(2)
    }
  },
  methods: {
    // 显示PCB费用明细弹框
    handlePcbFee() {
      const { type, data } = this
      const pcbType = type.includes('FPC') ? 'FPC' : 'PCB'
      const otherFields = {
        expressage: '运费',
        invoicefee: '税费',
        insurancefee: 'PCB品质服务费',
        discount_amount: '活动折扣'
      }
      this.$refs.feeFieldsDialogRef.open(pcbType, data.detail.pcb || {}, otherFields)
    },
    // 显示SMT费用明细弹框
    handleSmtFee() {
      const prices = Object.assign({}, this.data.detail.smt || {})
      this.$refs.feeFieldsDialogRef.open('SMT', prices)
    },
    // 显示BOM费用明细弹框
    handleBomFee() {
      const bomId = this.data.bomPrice.bomId
      this.$refs.bomItemDialogRef.open(bomId)
    }
  },
}
</script>

<style lang="scss" scoped>
.tips-box{
  width: 100%;
  margin-bottom:5px;
  .tips-content {
    padding: 2px 8px;
    font-size: 12px;
    line-height: 100%;
    font-weight: 400;
    color: #FF8800;
    border-radius: 4px;
    background-color: #FEF5E4;
  }
}
.tips-text{
  display: inline-block;
  font-size: 12px;
  color: #E6A23C;
}
.price-total-view {
  margin-top: 10px;
  width: 500px;
  background: #ffffff;
  ::v-deep {
    .price-view {
      border-color: $--color-warning;
      background: none;
    }
  }
}

.price-view {
  padding: 12px;
  border: 1px dashed $--border-color-base;
  border-radius: $--border-radius-base;
  >ul {
    line-height: 28px;
    text-align: right;
    >li {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
    }
  }
  .price-view__value {
    display: block;
    width: 100px;
    &.has-tips,
    &.has-handle {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &.has-handle {
      .base-tip-popover__icon {
        cursor: pointer;
      }
    }
    &.has-active {
      position: relative;
      margin-bottom: 20px;
      .has-active__tips {
        position: absolute;
        right: 0;
        top: 24px;
        display: inline-block;
        line-height: 1;
        padding: 4px;
        padding-left: 10px;
        font-size: 12px;
        white-space: nowrap;
        color: #FF8800;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        background-color: #FEF5E4;
        &::after {
          content: '';
          position: absolute;
          top: -4px;
          right: 20px;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 5px solid #FEF5E4;
        }
      }
    }
  }
  .price-view__handle {
    display: block;
    width: 14px;
    height: 14px;
    cursor: pointer;
    background: url('~@@/assets/img/icons/icon_question_warning.png');
    &:hover {
      background: url('~@@/assets/img/icons/icon_question_warning_hover.png');
    }
  }
  .price-view__desc {
    width: 100%;
    line-height: 20px;
    >span {
      padding: 2px 4px;
      font-size: 12px;
      border-radius: 2px;
      color: #888888;
      background-color: #F5F7FA;
      >span {
        color: #333333;
      }
    }
    
  }
}
</style>